import React, { useState } from "react";
import { FaTrash, FaCirclePlus } from "react-icons/fa6";

const EditableTableComponent = ({ columns, initialData, heading }) => {
  const [data, setData] = useState(initialData);
  const [columnHeaders, setColumnHeaders] = useState(columns);

  const handleEdit = (rowId, columnId, value) => {
    const updatedData = data.map((row, index) =>
      index === rowId ? { ...row, [columnId]: value } : row
    );
    setData(updatedData);
  };

  const sanitizeInput = (input) => {
    return input.replace(/[^a-zA-Z0-9.\s]/g, "");
  };

  const handleHeaderEdit = (index, newHeader) => {
    const sanitizedHeader = sanitizeInput(newHeader);
    const updatedHeaders = columnHeaders.map((col, colIndex) =>
      colIndex === index ? { ...col, header: sanitizedHeader } : col
    );
    setColumnHeaders(updatedHeaders);
  };

  const handleContentEditableChange = (rowId, columnId, e) => {
    const rawValue = e.currentTarget.textContent;
    const sanitizedValue = sanitizeInput(rawValue);
    e.currentTarget.textContent = sanitizedValue;
    handleEdit(rowId, columnId, sanitizedValue);
  };

  const addRowBelow = (rowIndex) => {
    const newRow = columns.reduce((acc, col) => {
      acc[col.accessor] = ""; // Create an empty row with empty values for each column
      return acc;
    }, {});
    const updatedData = [
      ...data.slice(0, rowIndex + 1),
      newRow,
      ...data.slice(rowIndex + 1),
    ];
    setData(updatedData);
  };

  // Delete row by index
  const deleteRow = (rowIndex) => {
    const updatedData = data.filter((_, index) => index !== rowIndex);
    setData(updatedData);
  };

  return (
    <div>
      <div className="heading pb-1 text-[15px] font-semibold text-[#4c4c4c]">
        {heading}
      </div>
      <div className="max-h-[18rem] drilltable">
        <table className="w-full border-collapse">
          <thead className="sticky text-white top-0 bg-[#2A5775] text-left z-[1]">
            <tr className="text-[12px] border text-center border-gray-300 bg-[#2A5775]">
              {columnHeaders.map((col, index) => (
                <th
                  key={col.accessor}
                  className="border p-[6px] "
                  style={{
                    width: col.width || "auto",
                    textAlign: col.headerAlign || "center",
                  }}
                  contentEditable
                  suppressContentEditableWarning={true}
                  onBlur={(e) => handleHeaderEdit(index, e.target.textContent)}
                  onKeyDown={(e) => {
                    if (
                      !e.key.match(/^[a-zA-Z0-9.\s\b]$/) &&
                      e.key.length === 1
                    ) {
                      e.preventDefault();
                    }
                  }}
                >
                  {col.header}
                </th>
              ))}
              <th className="hidden-th"></th>
            </tr>
          </thead>
          <tbody>
            {data.map((row, rowIndex) => (
              <tr className="even:bg-gray-200 odd:bg-white" key={rowIndex}>
                {columns.map((col, colIndex) => (
                  <td
                    key={col.accessor}
                    className={`p-[1px] text-[12px] ${
                      colIndex === 0 ? "text-center bg-[#d4e1ec]" : "text-left"
                    } whitespace-nowrap border border-gray-300`}
                    style={{
                      width: col.width || "auto",
                      textAlign: col.align || "center",
                      whiteSpace: "normal",
                      wordWrap: "break-word",
                      wordBreak: "break-word",
                      maxWidth: "200px",
                      overflowWrap: "break-word",
                    }}
                  >
                    <div
                      contentEditable
                      suppressContentEditableWarning={true}
                      onBlur={(e) =>
                        handleContentEditableChange(rowIndex, col.accessor, e)
                      }
                      onKeyDown={(e) => {
                        if (
                          !e.key.match(/^[a-zA-Z0-9.\s\b]$/) &&
                          e.key.length === 1
                        ) {
                          e.preventDefault();
                        }
                      }}
                      className="w-full border"
                      style={{
                        minHeight: "5px",
                        whiteSpace: "normal",
                        wordWrap: "break-word",
                        wordBreak: "break-word",
                        overflowWrap: "break-word",
                        paddingLeft: "3px",
                      }}
                    >
                      {row[col.accessor]}
                    </div>
                  </td>
                ))}
                <td className="flex items-baseline justify-center p-[2px] gap-1 hidden-td">
                  <FaCirclePlus
                    onClick={() => addRowBelow(rowIndex)}
                    className="cursor-pointer text-green-500 hover:text-green-700 text-center mt-[2px]"
                    size={14}
                    title="Click to Add row below"
                  />
                  <FaTrash
                    onClick={() => deleteRow(rowIndex)}
                    className="cursor-pointer text-red-500 hover:text-red-700 text-center  mt-[2px]"
                    size={14}
                    title="Click to Delete row"
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default EditableTableComponent;
